<template>
  <div class="panel-wrapper">
    <p class="panel-title">{{ $t('app.campaign.newPage.slidingPanel.campaignConfig.title') }}</p>
    <div tabindex="0" @keydown.enter="save" v-if="currentCampaign" class="basic-info-panel-content">
      <ChooseSpace v-model="currentCampaign"></ChooseSpace>
      <EnterCampaignName v-model="currentCampaign"></EnterCampaignName>
      <EnterJob v-model="currentCampaign"></EnterJob>
    </div>
    <div class="separator"></div>
    <div class="subtitle">{{ $t('app.campaign.newPage.recap.environmentSection.title') }}</div>
    <div v-if="currentCampaign" class="environment-selection">
      <div class="environment">
        <div class="environment-header">
          <input name="env" type="radio" id="construction" value="construction_site" v-model="currentCampaign.assessment.environment"></input>
          <label for="construction">{{ $t('app.campaign.newPage.slidingPanel.environment.construction_site.title') }}</label>
        </div>
        <div class="environment-subtitle">{{ $t('app.campaign.newPage.slidingPanel.environment.construction_site.description') }}</div>
        <img src="@/assets/images/img/construction_site.png" class="environment-preview"></img>
      </div>
      <div class="vertical-separator"></div>
      <div class="environment">
        <div class="environment-header">
          <input name="env" type="radio" id="station" value="planet_station" v-model="currentCampaign.assessment.environment"></input>
          <label for="station">{{ $t('app.campaign.newPage.slidingPanel.environment.planet_station.title') }}</label>
        </div>
        <div class="environment-subtitle">{{ $t('app.campaign.newPage.slidingPanel.environment.planet_station.description') }}</div>
        <img src="@/assets/images/img/planetary_station.png" class="environment-preview"></img>
      </div>
    </div>
    <div class="edit-buttons">
      <Button class="green sm" :label="$t('app.campaign.newPage.slidingPanel.buttons.save')" @click="save"></Button>
      <Button class="secondary sm" :label="$t('app.campaign.newPage.slidingPanel.buttons.cancel')" @click="emit('close')"></Button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";


.panel-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
  width: 800px;

  .separator {
    width: 100%;
    height: 1px;
    background-color: var(--light-grey-color);
  }

  .vertical-separator {
    width: 1px;
    height: 100%;
    background-color: var(--light-grey-color);
  }
}

.subtitle {
  font-size: 14px;
  font-weight: 600;
}

.panel-title {
  color: var(--secondary-color);
  font-family: $bioSans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 8px;
}

.basic-info-panel-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.environment-selection {
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;

  .environment {
    display: flex;
    flex-direction: column;
    gap: 16px;

    flex: 1;
    flex-basis: 50%;

    .environment-header {
      display: flex;
      gap: 8px;
      align-items: end;
    }

    .environment-subtitle {
      color: var(--secondary-color);
      font-family: $bioSans;
      font-size: 12px;
      font-style: italic;
      font-weight: 400;
      line-height: normal;
      text-align: justify;
      //width: 40vw;
      text-wrap: wrap;
    }

    .environment-preview {
      border-radius: 6px;
      width: 100%;
      aspect-ratio: 16/9;
    }
  }
}

.edit-buttons {
  //margin-top: 12px;
  width: 100%;
  display: flex;
  gap: 12px;
  font-size: 12px;
  justify-content: start;
}

</style>

<script setup lang="ts">
import EnterCampaignName from '@/views/app/campaigns/newCampaign/partials/steps/EnterCampaignName.vue';
import ChooseSpace from '@/views/app/campaigns/newCampaign/partials/steps/ChooseSpace.vue';
import EnterJob from '@/views/app/campaigns/newCampaign/partials/steps/EnterJob.vue';
import Button from '@/components/global/Button.vue';
import { CampaignCreation } from '@/types/campaign';

const props = defineProps<{
  campaign: CampaignCreation,
}>();

const currentCampaign: Ref<CampaignCreation> = ref(undefined);

const emit = defineEmits<{
  (e: 'save', value: CampaignCreation): void,
  (e: 'valid', value: boolean): void,
  (e: 'close'): void,
}>();

function save() {
  emit('save', structuredClone(toRaw(currentCampaign.value)));
  emit('close');
}

onMounted(() => {
  currentCampaign.value = structuredClone(toRaw(props.campaign));
});
</script>